import { Component, Vue } from 'vue-property-decorator';
import { GetDisplayPriorities, Mall } from 'supporter';
import { getCurrency, getLocalStorageMalls, toI18n } from '@/utils/commonUtils';

@Component
export default class ProductPriorityDataMixin extends Vue {
 public mallInfo: Mall[] = getLocalStorageMalls();

  public isModified = false;
  public searchRespones: GetDisplayPriorities[] = [];
  public dataLength = 0;
  public currentMallNo = -1;

  public searchTypeForExcel = 'mallProductNo';

  public get searchTypeExcelDownURL(): string {
    return `Upload_ProductDisplayPriority_${this.searchTypeForExcel === 'mallProductNo' ? 'ProductNo' : 'ProductManagementCode'}_Sample.xlsx`;
  }

  public keyword = '';
  public searchType = 'mallProductNo';

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }

  public get keywordPlaceHolderTxt(): string {
    if (this.searchType === 'mallProductNo') {
      return this.toI18n('PRODUCT_PRIORITY_PLACEHOLDER1');
    } else {
      return this.toI18n('PRODUCT_PRIORITY_PLACEHOLDER2');
    }
  }

  public isInvalidOfKeyword = false;
  public invalidMsg = '';

  public gridProps = {
    columns: [
      {
        header: this.toI18n('PRODUCT_PRIORITY_PRODUCT_NUMBER'),
        name: 'productNo',
        align: 'center',
        minWidth: 95
      },
      {
        header: this.toI18n('PRODUCT_PRIORITY_PRODUCT_MANAGEMENT_CODE'),
        name: 'productManagementCd',
        align: 'center',
        minWidth: 95
      },
      {
        header: this.toI18n('PRODUCT_PRIORITY_PRODUCT_NAME'),
        name: 'productName',
        align: 'left',
        minWidth: 240,
        formatter: ({ value, row }: any): string => {
          const TAG = {
            platformDisplayPcYn: '<span class="tag">PC</span>',
            platformDisplayMobileYn: '<span class="tag">M</span>',
            platformDisplayMobileWebYn: '<span class="tag">MW</span>'
          };
          const targetPlatforms = ['platformDisplayPcYn', 'platformDisplayMobileYn', 'platformDisplayMobileWebYn'].filter((v): boolean => row[v] === 'Y').map((v): string => v);
          if (targetPlatforms.length > 2) {
            return value;
          }

          const tag = targetPlatforms.map((v): string => TAG[v]);
          return `<div class='uio_bx'>${tag.join('')}</div> ${value}`;
        }
      },
      {
        header: this.toI18n('PRODUCT_PRIORITY_BRAND'),
        name: 'brandName',
        align: 'left',
        minWidth: 95
      },
      {
        header: this.toI18n('PRODUCT_PRIORITY_PARTNER'),
        name: 'partnerName',
        align: 'center',
        minWidth: 100
      },
      {
        header: this.toI18n('PRODUCT_PRIORITY_APPROVAL_STATUS'),
        name: 'applyStatusType',
        align: 'center',
        minWidth: 100,
        formatter: ({ value }: any): any => {
          let text = '';
          switch (value) {
            case 'REGISTRATION_READY':
              text = this.toI18n('PRODUCT_PRIORITY_WAITING_FOR_REGISTRATION');
              break;
            case 'APPROVAL_READY':
              text = this.toI18n('PRODUCT_PRIORITY_WAITING_FOR_APPROVAL');
              break;
            case 'APPROVAL_REJECTION':
              text = this.toI18n('PRODUCT_PRIORITY_REJECTION_OF_APPROVAL');
              break;
            case 'SALE_AGREEMENT_READY':
              text = this.toI18n('PRODUCT_PRIORITY_WAITING_FOR_SALES_AGREEMENT');
              break;
            case 'SALE_AGREEMENT_REJECTION':
              text = this.toI18n('PRODUCT_PRIORITY_REJECTION_OF_SALES_AGREEMENT');
              break;
            case 'AFTER_APPROVAL_READY':
              text = this.toI18n('PRODUCT_PRIORITY_WAITING_FOR_APPROVAL_AFTER_MODIFICATION');
              break;
            case 'AFTER_APPROVAL_REJECTION':
              text = this.toI18n('PRODUCT_PRIORITY_REJECT_APPROVAL_AFTER_MODIFICATION');
              break;
            default:
              text = this.toI18n('PRODUCT_PRIORITY_APPROVAL_COMPLETED');
              break;
          }
          return text;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: this.toI18n('PRODUCT_PRIORITY_SALES_STATUS'),
        name: 'saleStatusType',
        align: 'center',
        minWidth: 100,
        formatter: ({ value }: any): string => {
          let saleStatusType = '';
          switch (value) {
            case 'PRE_APPROVAL_STATUS':
              saleStatusType = '-'; //this.toI18n('PRODUCT_PRIORITY_BEFORE_APPROVAL_COMPLETION');
              break;
            case 'ON_PRE_SALE':
              saleStatusType = this.toI18n('PRODUCT_PRIORITY_PRE_ORDER');
              break;
            case 'WAITING_SALE':
              saleStatusType = this.toI18n('PRODUCT_PRIORITY_WAITING_FOR_SALE');
              break;
            case 'ON_SALE':
              saleStatusType = this.toI18n('PRODUCT_PRIORITY_SALE');
              break;
            case 'END_SALE':
              saleStatusType = `<span class='text-red'>${this.toI18n('PRODUCT_PRIORITY_END_OF_SALE')}</span>`;
              break;
          }
          return saleStatusType;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: this.toI18n('PRODUCT_PRIORITY_SALES_SETTING_STATUS'),
        name: 'saleSettingStatusType',
        align: 'center',
        minWidth: 100,
        formatter: ({ value }: any): string => {
          let saleSettingStatusType = '';
          switch (value) {
            case 'AVAILABLE_FOR_SALE':
              saleSettingStatusType = this.toI18n('PRODUCT_PRIORITY_AVAILABLE_FOR_SALE');
              break;
            case 'STOP_SELLING':
              saleSettingStatusType = `<span class='text-red'>${this.toI18n('PRODUCT_PRIORITY_STOP_SELLING')}</span>`;
              break;
            case 'PROHIBITION_SALE':
              saleSettingStatusType = `<span class='text-red'>${this.toI18n('PRODUCT_PRIORITY_PROHIBITION_OF_SALE')}</span>`;
              break;
          }

          return saleSettingStatusType;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: this.toI18n('PRODUCT_PRIORITY_EXHIBITION_STATUS'),
        name: 'displayable',
        align: 'center',
        minWidth: 100,
        formatter: ({ value }: any): string => {
          return value ? this.toI18n('PRODUCT_PRIORITY_DISPLAY_POSSIBLE') : this.toI18n('PRODUCT_PRIORITY_NO_EXHIBITION');
        }
      },
      {
        header: this.toI18n('PRODUCT_PRIORITY_FRONT_UNEXPOSURE'),
        name: 'onlyAccessUrl',
        align: 'center',
        minWidth: 100,
        formatter: ({ value }) => {
          return value ? this.toI18n('PRODUCT_PRIORITY_FRONT_UNEXPOSURE') : this.toI18n('PRODUCT_PRIORITY_FRONT_EXPOSURE');
        }
      },
      {
        header: this.toI18n('PRODUCT_PRIORITY_DISCOUNT_APPLICABLE_PRICE'),
        name: 'priceAppliedImmediateDiscount',
        align: 'center',
        minWidth: 100,
        formatter: ({ value }: any): string => {
          const parts = [value.toString()];
          let commaVal = '';
          if (parts.length == 1) {
            commaVal = `${parts[0].replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')}`;
          } else if (parts.length == 2) {
            commaVal = `${parts[0].replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')}.${parts[1]}`;
          } else {
            commaVal = '';
          }
          return commaVal;
        }
      },
      {
        header: this.toI18n('PRODUCT_PRIORITY_AVAILABLE_STOCK'),
        name: 'stock',
        align: 'center',
        minWidth: 100,
        formatter: ({ value, row }: any): string => {
          return value ? (row.optionType === 'COMBINATION' ? `${row.representStockCnt} (${value})` : `${value}`) : `<span class='text-red'>${this.toI18n('PRODUCT_PRIORITY_SOLD_OUT')}</span>`;
        }
      },
      {
        header: this.toI18n('PRODUCT_PRIORITY_DELETE'),
        name: 'removeBtn',
        align: 'center',
        minWidth: 100,
        formatter: ({ row }: any): string => {
          return `<button class='removeBtn' data-action='removeProduct' data-product-no='${row.productNo}'>${this.toI18n('PRODUCT_PRIORITY_DELETE')}</button>`;
        }
      }
    ]
  };

  public excelColumns = [
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_PRODUCTNO'), name: 'productNo' }, //Old: mallProductNo
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_MALLNAME'), name: 'mallName' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_PRODUCTNAME'), name: 'productName' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_PRODUCTMANAGEMENTCD'), name: 'productManagementCd' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_BRANDNAME'), name: 'brandName' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_SALEMETHODTYPE'), name: 'saleMethodType' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_PARTNERNAME'), name: 'partnerName' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_ADMINNAME'), name: 'adminName' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_COMMISSIONRATE'), name: 'commissionRate' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_SUPPLYPRICE'), name: 'supplyPrice' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_PURCHASEPRICE'), name: 'purchasePrice' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_APPROVALSTATUSTYPE'), name: 'approvalStatusType' }, //Old: applyStatusTypeLabel
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_SALESTATUSTYPE'), name: 'saleStatusType' }, //Old: saleStatusTypeLabel
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_NAME'), name: 'saleSettingStatusType' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_FRONTDISPLAYABLE'), name: 'frontDisplayable' }, //Old: frontDisplayYn
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_SALEPERIOD'), name: 'salePeriod' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_SALEPRICE'), name: 'salePrice' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_IMMEDIATEDISCOUNTAMOUNT'), name: 'immediateDiscountAmount' }, //Old: immediateDiscountValue
    {
      header: this.toI18n('PRODUCT_PRIORITY_EXCEL_APPLIEDIMMEDIATEDISCOUNTPRICE'),
      name: 'appliedImmediateDiscountPrice'
    }, //Old: discountApplyPrice
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_TOTALCNT'), name: 'totalCnt' }, //productStock.totalCnt //Old: stockCnt
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_TOTALSALECNT'), name: 'totalSaleCnt' }, //productStock.totalSaleCnt //Old: saleCnt
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_CANPROMOTION'), name: 'canPromotion' }, //Old: promotionYn
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_REGISTERPRICECOMPARINGSITE'), name: 'registerPriceComparingSite' }, // { header: '가격비교사이트등록', name: 'comparingPriceSite' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_DISPLAYCATEGORYNAMES'), name: 'displayCategoryNames' }, //Array //Old: displayCategoryFullname
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_GROUPTYPE'), name: 'groupType' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_DELIVERABLE'), name: 'deliverable' }, //Old: deliveryYn
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_SHIPPINGAREATYPE'), name: 'shippingAreaType' },
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_DELIVERYFEETYPE'), name: 'deliveryFeeType' }, //Old: deliveryConditionType
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_DELIVERYCHARGE'), name: 'deliveryCharge' }, //Old: deliveryAmt
    { header: this.toI18n('PRODUCT_PRIORITY_EXCEL_SHIPPINGCOMBINABLE'), name: 'shippingCombinable' } //Old: deliveryCombinationYn
  ];

  public get USMallNos(): Mall[] {
  return this.mallInfo.filter((mall: Mall): any => mall.countryCode === 'US').map((mall): any => mall.mallNo) || [];
  }

  public excelFormatter = {
    onlyAccessUrl: ({value}) => {
      return value ? window.$t('PRODUCT_PRIORITY_FRONT_UNEXPOSURE') : window.$t('PRODUCT_PRIORITY_FRONT_EXPOSURE');
    },
    frontDisplayable: ({value}: any): string => {
      return value === 'N' ? window.$t('PRODUCT_PRIORITY_NO_EXHIBITION') : window.$t('PRODUCT_PRIORITY_DISPLAY_POSSIBLE');
    },
    immediateDiscountAmount: ({row}: any): number => {
      return parseInt(getCurrency(row.immediateDiscountAmount, this.USMallNos.includes(this.currentMallNo as any)).replace(',', ''), 10);
    },
    registerPriceComparingSite: ({value}: any): string => {
      return value ? 'Y' : 'N';
    },
    deliverable: ({value}: any): string => {
      return value === 'N' ? window.$t('PRODUCT_PRIORITY_NO_DELIVERY') : window.$t('PRODUCT_PRIORITY_DELIVERY');
    },
    deliveryCharge: ({value, row}: any): string => {
      if (row.deliverable === 'N') {
        return '';
      }

      if (row.deliveryCharge === null) {
        return '0';
      }

      return value;
    },
    commissionRate: ({value, row}: any): string => {
      // if (row.saleMethodType === '사입' || row.commissionType === 'PURCHASE_PRICE') {
      if (row.saleMethodType === window.$t('PRODUCT_PRIORITY_BUY')) {
        return '-';
      }

      return `${value}%`;
    },
    supplyPrice: ({row}: any): string => {
      if (row.saleMethodType === window.$t('PRODUCT_PRIORITY_BUY')) {
        return '-';
      }
      const value = (row.appliedImmediateDiscountPrice * (100 - row.commissionRate)) / 100;
      return getCurrency(value, this.USMallNos.includes(this.currentMallNo as any));
    },
    purchasePrice: ({row}: any): string => {
      if (row.saleMethodType === window.$t('PRODUCT_PRIORITY_CONSIGNMENT')) {
        return '-';
      }

      const parts = [row.supplyPrice.toString()];
      let commaVal = '';
      if (parts.length == 1) {
        commaVal = `${parts[0].replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')}`;
      } else if (parts.length == 2) {
        commaVal = `${parts[0].replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')}.${parts[1]}`;
      } else {
        commaVal = '';
      }
      return commaVal;
    },
    totalCnt: ({row: {productStock}}: any): number => {
      if (productStock) {
        return productStock.totalCnt;
      }
      return 0;
    },
    totalSaleCnt: ({row: {productStock}}: any): number => {
      if (productStock) {
        return productStock.totalSaleCnt;
      }
      return 0;
    }
  };
}
